export default __webpack_public_path__ + "static/media/CompactedCoal.256.f95711ce.png";